export const THREE_D = 'ThreeD';
export const ADYEN_HPP = 'adyen_hpp';
